import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer, ViewChild} from '@angular/core';
import { RiderNotesService } from '../../../riders/rider-notes/rider-notes.service';
import { ReservationNoteService } from '../reservation-note.service';
import { NoteModel, TripNotesModel } from '../tripNote.model';
import { INoteCategory } from '../../../../core/interfaces/complaints.interface';
import { ICompany } from '../../../../core/interfaces/company.interface';
import { CompanyService } from '../../../../core/services/company.service';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';
import { NoteTypeEnum } from '../../../../core/enums/note-type.enum';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { NoteTemplateService } from '../../../../core/services/note-template.service';
import {INoteTemplate} from '../../../../core/interfaces/note.interface';

@Component({
  selector: 'app-reservation-note-add',
  templateUrl: './reservation-note-add.component.html',
  styleUrls: ['./reservation-note-add.component.scss']
})

export class ReservationNoteAddComponent implements OnInit, OnDestroy {
    @Input() tripid: number;
    @Input() riderid: number;
    @Input() providerid: number;
    @Input() noteid: number;
    @Input() standingordernoteid?: number;
    @Input() notetype = '';
    @Input() soId;
    @Input() editNote = true;
    @Output() closeForm = new EventEmitter<boolean>();
    @Output() closeAfterSave = new EventEmitter<any>();
    @ViewChild('btnSave') btnSave;
    public isClientUser: boolean = JSON.parse(localStorage.getItem('currentUser')).isClient;
    public data  = <TripNotesModel>{};
    public note  = <NoteModel>{};
    public items = [];
    public itemsComplaint = [];
    public itemStatus = [];
    public showComplaint = true;
    public showComplaint2 = false;
    public showProcessing = false;
    public reportedBy: INoteCategory[] = [];
    public providers: ICompany[] = [];
    public disableIsAllLegs: boolean;
    public showSpeedNote = false;
  originalNoteTypeId: number;


    isSO = false;

    get isEditAndNoteTypeComplaint(): boolean {
      return this.note.noteid > 0 && this.note.notetypeid === NoteTypeEnum.Complaint;
    }

  @Input() standingOrderId?: number;
  validDescription: boolean;
  private subscriptions: Subscription[] = [];
  constructor(
    protected service: ReservationNoteService,
    protected riderNoteService: RiderNotesService,
    protected renderer: Renderer,
    private _companyService: CompanyService,
    protected elementRef: ElementRef,
    private sweetAlertHelper: SweetAlertHelper,
    private loading: T2LoadingService,
    protected noteTemplateService: NoteTemplateService
  ) {
    this.subscriptions.push(this.service.getTypesNotes(5).subscribe( data => this.itemStatus = data));
    this.subscriptions.push(this.service.getTypesNotes(7).subscribe(
      (data: INoteCategory[]) => {
        this.reportedBy = data;
        if (this.isClientUser && data.length === 1) {
          this.note.complaintreportedbyid = data[0].notecategoryvalueid;
        }
      }
    ));
  }

  loadSelector() {
    this.loading.show();
    this.subscriptions.push(
      this.service.getTypesNotes(2).subscribe({
        next: (data: any) => {
          if (this.noteid && this.note && this.note.noteid) {
            this.note.notetypeid = this.note.noteregistertypeid;
            this.items = data.filter(
              (f: { notecategoryvalueid: number }) =>
                f.notecategoryvalueid === this.note.noteregistertypeid
            );
          } else {
            this.items = data.filter(
              (f: { notecategoryvalueid: NoteTypeEnum }) =>
                f.notecategoryvalueid !== NoteTypeEnum.ProviderNegotiated &&
                f.notecategoryvalueid !== NoteTypeEnum.Billing &&
                f.notecategoryvalueid !== NoteTypeEnum.ClientNegotiated &&
                f.notecategoryvalueid !== NoteTypeEnum.Negotiated
            );
          }
          this.loading.hiden();
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error);
        },
      })
    );
  }

  get isRiderNote(): boolean {
    return !this.noteid || (this.note && this.note.notetypeid === NoteTypeEnum.Rider);
  }

  ngOnInit() {
      this.data.tripid = this.tripid;
      if ( this.noteid !== undefined ) {
          if (this.notetype === 'Rider') {
              this.note.notetypeid = 0;
              this.subscriptions.push(this.riderNoteService.getRiderNote(this.noteid).subscribe(
                  data => { this.loadData(data); }
              ));
          } else if (this.soId && this.notetype === 'Standing Order') {
            this.subscriptions.push(this.service.getStandingNote(this.noteid).subscribe(
              data => {
                if (data) {
                  this.standingordernoteid = data.standingordernoteid;
                  this.loadData(data);
                }
              }
            ));
          } else {
            this.subscriptions.push(this.service.getTripNote(this.noteid).subscribe(
              data => {
                  this.loadData(data);
              }
            ));
          }
      }else {
          this.note.notetypeid = 5;
      }

      if (this.standingOrderId) {
        this.isSO = true;
        if (this.standingordernoteid) {
          this.subscriptions.push(this.service.getStandingNote(this.standingordernoteid).subscribe(
            data => {
              this.loadData(data);
            }
          ));
        }
        this.note.notetypeid = 31;
      }
      this.getProviders();
      this.getIten();
      this.loadSelector();
      this.initSubscriptions();
  }

  initSubscriptions(): void {
    this.subscriptions.push(
      this.noteTemplateService.getTemplateNote()
      .subscribe({
        next: (res: any) => this.noteTemplateService.sendNoteTemplateData(res),
        error: (e) => this.sweetAlertHelper.captureException(e)
      })
    );
    this.subscriptions.push(
      this.service.noteTemplateSubject$.subscribe({
        next: (res) => {
          if (res && res.rowData !== null) {
            this.note.description = res.rowData.description;
            this.validDescription = true;
          }
        }
      })
    );
    this.subscriptions.push(
      this.noteTemplateService.noteTemplateDataByClick$
        .subscribe({
          next: ({description}: INoteTemplate) => {
            this.note.description = description;
            this.validDescription = true;
          }
        })
    );
  }

    /**
     * @description
     */
    public saveTripNote() {
        if (this.note.notetypeid !== 0) {
          if (this.standingOrderId || this.note.notetypeid === 31) {
            this.saveSONote();
          } else {
            this.renderer.setElementProperty(this.btnSave.nativeElement,
              'disabled', true);
            this.data.moduleid = 36;
            this.data.note = this.note;
            this.showProcessing = true;
            if (this.noteid === undefined) {
              this.subscriptions.push(this.service.postTripNote(this.data).subscribe(
                data => {
                  this.sweetAlertHelper.createCustomAlert({
                    text: 'Trip Note Created Successfully',
                    type: 'success',
                    confirmButtonText: 'Ok'
                  }).then(() => {
                    this.returnSave(data);
                  });
                },
                error => {
                  this.swalError(error);
                }
              ));
            } else {
              this.note.notetypeid = this.originalNoteTypeId;
              this.subscriptions.push(this.service.putTripNote(this.data).subscribe(
                data => {
                  this.sweetAlertHelper.createCustomAlert({
                    text: 'Trip Note Updated Successfully',
                    type: 'success',
                    confirmButtonText: 'Ok'
                  }).then(() => {
                    this.returnSave(data);
                  });
                }, error => {
                  this.swalError(error);
                }
              ));
            }
          }
        } else {
            this.saveRiderNote();
        }
    }

  swalError(error) {
    let textError;
    error.modelstate
    ? textError = error.modelstate['input.note.description'].shift()
    : textError = error.message;
    this.sweetAlertHelper.createCustomAlert({
      text: textError,
      type: 'error',
    }).then(() => {
      this.closeForm.emit();
    });
  }

    /**
     * @description
     */
    private saveRiderNote() {
        const ridernote = {};
        ridernote['riderid'] = this.riderid;
        ridernote['moduleid'] = 36;
        if (this.noteid === undefined) {
            ridernote['note'] = {description: this.note.description};
            this.riderNoteService.postRiderNote(ridernote).subscribe(
                data => {
                    this.sweetAlertHelper.createCustomAlert({
                      text: 'Rider Note Created Successfully',
                      type: 'success',
                      confirmButtonText: 'Ok'
                    }).then(() => {
                      this.returnSave(data);
                    });
                }, error => {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Error!',
                    text: error.message,
                    type: 'error',
                  });
                }
            );
        }else {
            ridernote['ridernoteid'] = this.noteid;
            ridernote['note'] = {noteid: this.note.noteid, description: this.note.description};
            this.riderNoteService.putRiderNote(ridernote).subscribe(
                data => {
                    this.sweetAlertHelper.createCustomAlert({
                      text: 'Rider Note Updated Successfully',
                      type: 'success',
                      confirmButtonText: 'Ok'
                    }).then(() => {
                      this.returnSave(data);
                    });
                }, error => {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Error!',
                    text: error.message,
                    type: 'error'
                  });
                }
            );

        }
    }

    /**
     * @description
     * @param data
     */
    public loadData(data) {
      this.disableIsAllLegs = data.note.isalllegs;
      this.note.noteid        = data.note.noteid;
      this.note.notetypeid    = this.notetype === 'Rider' ? 0 : data.note.notetypeid;
      this.originalNoteTypeId = this.note.notetypeid;
      this.note.description   = data.note.description;
      this.note.isalllegs     = data.note.isalllegs;
      this.note.noteregistertypeid = this.notetype === 'Rider' ? NoteTypeEnum.Rider : data.note.noteregistertypeid;
      this.validDescription = true;
      if ( data.note.notetypeid === 6 ) {
        this.note.notestatusid      = data.note.notestatusid;
        this.note.complaintreportedbyid = data.note.complaintreportedbyid;
        this.note.caller = data.note.caller ? data.note.caller : '';
        this.note.notecomplaintid   = data.note.notecomplaintid;
        this.note.complaintproviderid = data.note.complaintproviderid ? data.note.complaintproviderid : '';
        this.note.calleremail = data.note.calleremail;
        this.note.ahcacomplaintid = data.note.ahcacomplaintid;
        this.loadWhenIsComplaint();
      }
      if (this.noteid && this.note) {
        this.loadSelector();
      }
    }

    /**
     * @description
     * @param data
     */
    public returnSave(data) {
        this.closeAfterSave.emit(data);
    }

    /**
     * @description
     */
    public loadWhenIsComplaint() {
        this.showComplaint = false;
        this.showComplaint2 = true;
        this.showSpeedNote = true;
    }

    /**
     * @description al cambiar tipo de nota
     * @param event
     */
    public onSelectNoteType(event: number) {
        if ( event === 6 ) {
          this.loadWhenIsComplaint();
          this.note.notestatusid = 9;
          this.note.complaintproviderid = this.providerid ? this.providerid : undefined;
        }else {
            this.showComplaint   = true;
            this.showComplaint2  = false;
            this.showSpeedNote   = false;
            this.note.notecomplaintid      = undefined;
            this.note.notestatusid         = undefined;
            this.note.complaintproviderid  = undefined;
            this.note.complaintreportedbyid  = undefined;
        }
    }

    /**
     * @description
     */
    public closeWindow() {
        this.closeForm.emit(true);
        this.service.noteTermplateSendData(null);
    }

    saveSONote() {
      this.showProcessing = true;
      if (this.standingordernoteid) {
        this.updateSONote();
      } else {
        this.data.StandingOrderId = this.standingOrderId ? this.standingOrderId : this.soId;
        this.data.StandingOrderNoteId = 0;
        this.data.moduleid = 36;
        this.data.note = this.note;
        this.service.postStandingNote(this.data).subscribe(data => {
          this.sweetAlertHelper.createCustomAlert({
            text: 'So Note Created Successfully',
            type: 'success',
            confirmButtonText: 'Ok'
          }).then(() => {
            this.returnSave(data);
          });
        }, error => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error!',
            text: error.message,
            type: 'error',
          });
        });
      }
        this.showProcessing = true;
    }


  updateSONote() {
    this.showProcessing = true;
    this.data.StandingOrderId = this.standingOrderId;
    this.data.StandingOrderNoteId = this.standingordernoteid;
    this.data.moduleid = 36;
    this.data.note = this.note;
    this.service.putStandingOrderNote(this.data).subscribe(data => {
      this.sweetAlertHelper.createCustomAlert({
        text: 'So Note Updated Successfully',
        type: 'success',
        confirmButtonText: 'Ok'
      }).then(() => {
        this.returnSave(data);
      });
    }, error => {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error!',
        text: error.message,
        type: 'error',
      });
    });
    this.showProcessing = true;
  }

  /**
   * @description trae todos los provider
   */
  private getProviders(): void {
    this.subscriptions.push(this._companyService.get().subscribe(
      (providerList: ICompany[]) => {
        this.providers = providerList;
      }
    ));
  }
  getIten() {
    this.subscriptions.push(this.service.getTypesNotes(4).subscribe(
      data => {
        this.itemsComplaint = data;
      }
    ));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  updateNoteDescription() {
    this.note.description ? this.validDescription = true : this.validDescription = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reservation-notes/reservation-note-add/reservation-note-add.component.ts